import Box from "./Box";
import Checkbox from "./Checkbox";
import FormError from "./FormError";
import PropTypes from "prop-types";
import React from "react";

function FormCheckbox({ checked, label, handleChange, error, name }) {
  return (
    <Box pt={20} position="relative">
      {error && (
        <FormError
          name={name}
          positionProps={{
            bottom: "-40px",
            left: "52px",
          }}
        >
          {error}
        </FormError>
      )}
      <Checkbox
        name={name}
        checked={checked}
        onClick={handleChange}
        error={error !== null && error !== undefined}
      >
        {label}
      </Checkbox>
    </Box>
  );
}

FormCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default FormCheckbox;
